import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo8/mesadevotacion.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { modulo8 } from "../../../routes/Module8";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo8/Actividad 1.mp3";

const Actividad1 = () => {
  const infoUnidad = modulo8.content[0];
  const infoAct = modulo8.content[0].activities[0];
  const crumbs = [
    {
      title: modulo8.title,
      url: "/" + modulo8.url,
    },
    {
      title:
        modulo8.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo8.content[0].activities[1].name}`,
    linkNext: `${modulo8.url}/${modulo8.content[0].path}/${modulo8.content[0].activities[1].path}`,
    titlePrev: modulo8.title,
    linkPrev: modulo8.url,
  };
  const metadata = {
    color: modulo8.color,
    title: `${modulo8.title} - ${infoAct.name}`,
    name: modulo8.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div className="row">
        <div className="col-md-8">
          <p>
            <small className={`c-${modulo8.color} hat-text`}>
              <FontAwesomeIcon icon={faEye} /> Observamos
            </small>
          </p>
          <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
          <ul>
            <li>Observa la imagen.</li>
          </ul>
        </div>
      </div>
      <div className="col-12">
        <img src={Imagen1} alt="Inicio" className="img-fluid" />
      </div>
      <ul>
        <li>
          Conversa con un compañero, compañera o familiar sobre las siguientes
          preguntas y escribe tus ideas.
        </li>
      </ul>
      <div className="row">
        <div className="col-lg-8 col-12">
          <p>¿Qué ocurre en la imagen? ¿Qué está haciendo la gente?</p>
          <textarea className="form-control mb-4" rows={3} />
          <p>
            ¿Qué documento llevan algunas personas en sus manos? ¿Para qué lo
            necesitan?
          </p>
          <textarea className="form-control mb-4" rows={3} />

          <p>¿Por qué hay gente haciendo cola? ¿Qué están esperando?</p>
          <textarea className="form-control mb-4" rows={3} />

          <p>¿Qué crees que está escrito en los paneles?</p>
          <textarea className="form-control mb-4" rows={3} />
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea la primera indicación. Observen la imagen. Lea la segunda
          indicación y las preguntas. Ayude a responder las preguntas a partir
          de lo que se observa: la gente está votando, llevan DNI, esperan su
          turno para votar, leen los paneles donde se señala en qué mesa deben
          votar.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
